import { search } from '../searchService';
import { post, put, del, getById } from '../apiService';
import type { Course } from '../../types/content/course';
import type { SearchParams } from '../../types/search';

export async function searchCourses(
  filter: object = {},
  params: SearchParams = {},
): Promise<Course[]> {
  return search<Course>('/course/search', filter, params);
}

export async function getCourseById(id: string, expand?: string): Promise<Course> {
  const qs = expand ? `?expand=${encodeURIComponent(expand)}` : '';
  return getById<Course>('/course', `${id}${qs}`);
}

export async function createCourse(data: Partial<Course>): Promise<Course> {
  return post<Course>('/course', data);
}

export async function updateCourse(id: string, data: Course): Promise<Course> {
  return put<Course>(`/course/${id}`, data);
}

export async function deleteCourse(id: string): Promise<void> {
  return del<void>(`/course/${id}`);
}
